import(/* webpackMode: "eager" */ "/codebuild/output/src1425782722/src/app/home/page.tsx");
